import { render, staticRenderFns } from "./ShareRequests.vue?vue&type=template&id=462bd0cd"
import script from "./ShareRequests.vue?vue&type=script&lang=js"
export * from "./ShareRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports